module.exports = __webpack_public_path__ + "img/ORCIDiD_iconvector.4af46c0c.svg";